// extracted by mini-css-extract-plugin
export default {"selectedProviderSection":"ProviderSelection_selectedProviderSection__WCQ1y","provider":"ProviderSelection_provider__zwHFO","required":"ProviderSelection_required__Yf+37"};